module.exports = __webpack_public_path__ + "img/skredfaresone.4bae6692.jpg";